function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import classNames from 'classnames';
import clamp from 'lodash.clamp';
import { DragDropContext, Droppable } from '@hello-pangea/dnd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { vsChevronRight, vsChevronLeft, vsChevronDown } from '@deephaven/icons';
import { useResizeObserver } from '@deephaven/react-hooks';
import DragUtils from "../DragUtils.js";
import Button from "../Button.js";
import NavTab from "./NavTab.js";
import "./NavTabList.css";
import { ContextActions } from "../context-actions/index.js";
import Popper from "../popper/Popper.js";
import DashboardList from "./DashboardList.js";
import { GLOBAL_SHORTCUTS } from "../shortcuts/index.js"; // mouse hold timeout to act as hold instead of click
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var CLICK_TIMEOUT = 500;

// mouse hold acceleration
var START_SPEED = 0.01;
var ACCELERATION = 0.0005;
function isScrolledLeft(element) {
  return element.scrollLeft === 0;
}
function isScrolledRight(element) {
  return (
    // single pixel buffer to account for sub-pixel rendering
    Math.abs(element.scrollLeft + element.clientWidth - element.scrollWidth) <= 1 || element.scrollWidth === 0
  );
}
function makeBaseContextActions(tab, tabs, onClose) {
  var _tab$isClosable = tab.isClosable,
    isClosable = _tab$isClosable === void 0 ? false : _tab$isClosable,
    key = tab.key;
  var contextActions = [];
  if (isClosable && onClose != null) {
    contextActions.push({
      title: 'Close',
      order: 10,
      group: 20,
      action: () => {
        onClose(key);
      }
    });
    var disabled = true;
    for (var i = tabs.length - 1; i > 0; i -= 1) {
      if (tabs[i].key === tab.key) break;
      if (tabs[i].isClosable === true) {
        disabled = false;
        break;
      }
    }
    contextActions.push({
      title: 'Close to the Right',
      order: 20,
      group: 20,
      action: () => {
        for (var _i = tabs.length - 1; _i > 0; _i -= 1) {
          if (tabs[_i].key === key) break;
          if (tabs[_i].isClosable === true) onClose(tabs[_i].key);
        }
      },
      disabled
    });
    contextActions.push({
      title: 'Close All',
      order: 30,
      group: 20,
      action: () => {
        tabs.forEach(t => {
          if (t.isClosable === true) onClose(t.key);
        });
      }
    });
  }
  return contextActions;
}
function NavTabList(_ref) {
  var activeKey = _ref.activeKey,
    tabs = _ref.tabs,
    onSelect = _ref.onSelect,
    onReorder = _ref.onReorder,
    onClose = _ref.onClose,
    makeContextActions = _ref.makeContextActions,
    renderAfterTabContent = _ref.renderAfterTabContent;
  var containerRef = useRef();
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isOverflowing = _useState2[0],
    setIsOverflowing = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isDashboardTabMenuShown = _useState4[0],
    setIsDashboardTabMenuShown = _useState4[1];
  var _useState5 = useState(true),
    _useState6 = _slicedToArray(_useState5, 2),
    disableScrollLeft = _useState6[0],
    setDisableScrollLeft = _useState6[1];
  var _useState7 = useState(true),
    _useState8 = _slicedToArray(_useState7, 2),
    disableScrollRight = _useState8[0],
    setDisableScrollRight = _useState8[1];
  var handleResize = useCallback(() => {
    if (containerRef.current == null) {
      return;
    }
    if (containerRef.current.clientWidth < containerRef.current.scrollWidth && tabs.length > 0) {
      setIsOverflowing(true);
    } else {
      setIsOverflowing(false);
    }
    setDisableScrollLeft(isScrolledLeft(containerRef.current));
    setDisableScrollRight(isScrolledRight(containerRef.current));
  }, [tabs]);
  useResizeObserver(containerRef.current, handleResize);
  var onDragEnd = useCallback(result => {
    DragUtils.stopDragging();

    // dropped outside the list
    if (!result.destination) {
      return;
    }
    onReorder === null || onReorder === void 0 || onReorder(result.source.index, result.destination.index);
  }, [onReorder]);
  var handleScroll = useCallback(() => {
    if (containerRef.current == null) {
      return;
    }
    var shouldDisableScrollLeft = isScrolledLeft(containerRef.current);
    if (shouldDisableScrollLeft !== disableScrollLeft) {
      setDisableScrollLeft(shouldDisableScrollLeft);
    }
    var shouldDisableScrollRight = isScrolledRight(containerRef.current);
    if (shouldDisableScrollRight !== disableScrollRight) {
      setDisableScrollRight(shouldDisableScrollRight);
    }
  }, [disableScrollLeft, disableScrollRight]);
  var continuousScrollRef = useRef({
    cancelClick: false
  });
  var handleLeftClick = useCallback(() => {
    if (containerRef.current == null || continuousScrollRef.current.cancelClick) {
      return;
    }
    var children = containerRef.current.children;
    for (var i = children.length - 1; i >= 0; i -= 1) {
      var child = children[i];
      // Subtract 5px from left edge to account for rounding of offset values
      if (child.offsetLeft < containerRef.current.scrollLeft - 5) {
        child.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'start'
        });
        return;
      }
    }
  }, []);
  var handleRightClick = useCallback(() => {
    if (containerRef.current == null || continuousScrollRef.current.cancelClick) {
      return;
    }
    var children = containerRef.current.children;
    for (var i = 0; i < children.length; i += 1) {
      var child = children[i];
      // Subtract 5px from right edge to account for rounding of offset values
      if (child.offsetLeft + child.offsetWidth - 5 > containerRef.current.scrollLeft + containerRef.current.offsetWidth) {
        child.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'end'
        });
        return;
      }
    }
  }, []);

  /**
   * Recurively called after initial timeout on mousedown. Continuously scroll with acceleration.
   * Cancelled by mouseup handler cancelling the animationFrame.
   * @param direction of scroll, left or right
   * @param startX starting position of scroll
   * @param deltaX delta from intial startX calculated recursively
   * @param prevTimestamp called on subsequent delta frames
   */
  var handleMouseRepeat = useCallback(function (direction, startX) {
    var deltaX = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var prevTimestamp = arguments.length > 3 ? arguments[3] : undefined;
    var container = containerRef.current;
    if (container == null) {
      return;
    }
    continuousScrollRef.current.cancelClick = true;
    if (direction === 'left') {
      // eslint-disable-next-line no-param-reassign
      container.scrollLeft = startX - deltaX;
    } else if (direction === 'right') {
      // eslint-disable-next-line no-param-reassign
      container.scrollLeft = startX + deltaX;
    }

    // eslint-disable-next-line no-param-reassign
    continuousScrollRef.current.rAF = requestAnimationFrame(timestamp => {
      var startTime = prevTimestamp !== null && prevTimestamp !== void 0 ? prevTimestamp : timestamp;
      var deltaTime = timestamp - startTime;
      var newDeltaX = START_SPEED * deltaTime + 0.5 * ACCELERATION * deltaTime ** 2;
      newDeltaX = Math.min(newDeltaX, container.scrollWidth);
      // scrollLeft enforces a limit but no point letting delta increment beyond scrollWidth

      handleMouseRepeat(direction, startX, newDeltaX, startTime);
    });
  }, []);
  var endContinuousScroll = useCallback(() => {
    var _continuousScrollRef$ = continuousScrollRef.current,
      holdTimer = _continuousScrollRef$.holdTimer,
      rAF = _continuousScrollRef$.rAF;
    if (holdTimer != null) {
      clearTimeout(holdTimer);
      continuousScrollRef.current.holdTimer = undefined;
    }
    if (rAF != null) {
      cancelAnimationFrame(rAF);
      continuousScrollRef.current.rAF = undefined;
    }
    window.removeEventListener('mouseup', endContinuousScroll);
  }, []);
  useEffect(() => () => window.removeEventListener('mouseup', endContinuousScroll), [endContinuousScroll]);
  var handleMouseDown = useCallback(direction => {
    if (containerRef.current != null) {
      continuousScrollRef.current.holdTimer = window.setTimeout(handleMouseRepeat, CLICK_TIMEOUT, direction, containerRef.current.scrollLeft);
    }
    continuousScrollRef.current.cancelClick = false;
    window.addEventListener('mouseup', endContinuousScroll);
  }, [endContinuousScroll, handleMouseRepeat]);
  var handleMouseDownLeft = useCallback(() => {
    handleMouseDown('left');
  }, [handleMouseDown]);
  var handleMouseDownRight = useCallback(() => {
    handleMouseDown('right');
  }, [handleMouseDown]);

  // React binds to the root as a passive listener for wheel
  // This prevents the wheel event from being canceled
  // Bypass React's event system so we can prevent the default behavior
  // https://github.com/facebook/react/issues/14856
  useEffect(function handleWheel() {
    var _containerRef$current;
    var onWheel = e => {
      e.stopPropagation();
      e.preventDefault();
      var nav = e.currentTarget;
      var delta = Math.abs(e.deltaY) > Math.abs(e.deltaX) ? e.deltaY : e.deltaX;

      // Scrolling jumps too far sometimes, so clamp to get a smoother scroll
      nav.scrollLeft += clamp(delta, -30, 30);
    };
    (_containerRef$current = containerRef.current) === null || _containerRef$current === void 0 || _containerRef$current.addEventListener('wheel', onWheel);
    return () => {
      var _containerRef$current2;
      (_containerRef$current2 = containerRef.current) === null || _containerRef$current2 === void 0 || _containerRef$current2.removeEventListener('wheel', onWheel);
    };
  }, []);
  var tabContextActionMap = useMemo(() => {
    var tabContextActions = new Map();
    tabs.forEach(tab => {
      var key = tab.key;
      var contextActions = [() => makeBaseContextActions(tab, tabs, onClose), () => {
        var _makeContextActions;
        return (_makeContextActions = makeContextActions === null || makeContextActions === void 0 ? void 0 : makeContextActions(tab)) !== null && _makeContextActions !== void 0 ? _makeContextActions : [];
      }];
      tabContextActions.set(key, contextActions);
    });
    return tabContextActions;
  }, [makeContextActions, tabs, onClose]);
  var activeTabRef = useRef(null);
  var activeTab = tabs.find(tab => tab.key === activeKey);
  var navTabs = tabs.map((tab, index) => {
    var key = tab.key;
    var isActive = tab === activeTab;
    return /*#__PURE__*/_jsx(NavTab, {
      tab: tab,
      index: index,
      isActive: isActive,
      activeRef: activeTabRef,
      onSelect: onSelect,
      onClose: onClose,
      isDraggable: onReorder != null,
      contextActions: tabContextActionMap.get(key),
      renderAfterTabContent: renderAfterTabContent
    }, key);
  });
  useEffect(
  // Needs to be in a useEffect so the ref is updated
  function scrollActiveTabIntoView() {
    if (activeTabRef.current != null) {
      activeTabRef.current.scrollIntoView({
        block: 'nearest',
        inline: 'nearest'
      });
    }
  }, [activeKey]);
  var handleDashboardMenuClick = () => {
    setIsDashboardTabMenuShown(!isDashboardTabMenuShown);
  };
  var handleDashboardMenuSelect = tab => {
    setIsDashboardTabMenuShown(false);
    onSelect(tab.key);
  };
  var handleDashboardMenuClose = () => {
    setIsDashboardTabMenuShown(false);
  };
  return /*#__PURE__*/_jsxs("nav", {
    className: "nav-container",
    children: [isOverflowing && /*#__PURE__*/_jsx(Button, {
      kind: "ghost",
      icon: /*#__PURE__*/_jsx(FontAwesomeIcon, {
        icon: vsChevronLeft,
        transform: "grow-4"
      }),
      className: "tab-controls-btn tab-controls-btn-left",
      tooltip: "Scroll left",
      onClick: handleLeftClick,
      onMouseDown: handleMouseDownLeft,
      disabled: disableScrollLeft
    }), /*#__PURE__*/_jsx(DragDropContext, {
      onDragStart: DragUtils.startDragging,
      onDragEnd: onDragEnd,
      children: /*#__PURE__*/_jsx(Droppable, {
        droppableId: "droppable-tab-navigation",
        direction: "horizontal",
        children: (provided, snapshot) => /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread({
          ref: r => {
            if (r == null) {
              return;
            }
            containerRef.current = r;
            provided.innerRef(r);
          }
          // eslint-disable-next-line react/jsx-props-no-spreading
        }, provided.droppableProps), {}, {
          className: classNames('nav nav-tabs', {
            dragging: snapshot.draggingFromThisWith
          }),
          role: "tablist",
          onScroll: handleScroll,
          children: [navTabs, provided.placeholder]
        }))
      })
    }), isOverflowing && /*#__PURE__*/_jsx(Button, {
      kind: "ghost",
      icon: /*#__PURE__*/_jsx(FontAwesomeIcon, {
        icon: vsChevronRight,
        transform: "grow-4"
      }),
      className: "tab-controls-btn tab-controls-btn-right",
      tooltip: "Scroll right",
      onClick: handleRightClick,
      onMouseDown: handleMouseDownRight,
      disabled: disableScrollRight
    }), /*#__PURE__*/_jsx(Button, {
      kind: "ghost",
      icon: /*#__PURE__*/_jsx(FontAwesomeIcon, {
        icon: vsChevronDown,
        transform: "grow-4"
      }),
      className: "btn-dashboard-list-menu btn-show-dashboard-list",
      tooltip: "Search open dashboards",
      onClick: handleDashboardMenuClick,
      disabled: tabs.length < 2,
      style: {
        visibility: isOverflowing ? 'visible' : 'hidden',
        marginLeft: 'auto'
      },
      children: /*#__PURE__*/_jsx(Popper, {
        isShown: isDashboardTabMenuShown,
        className: "dashboard-list-menu-popper",
        onExited: handleDashboardMenuClose,
        options: {
          placement: 'bottom-start'
        },
        closeOnBlur: true,
        interactive: true,
        children: /*#__PURE__*/_jsx(DashboardList, {
          tabs: tabs,
          onSelect: handleDashboardMenuSelect
        })
      })
    }), /*#__PURE__*/_jsx(ContextActions, {
      actions: [{
        action: () => {
          setIsDashboardTabMenuShown(!isDashboardTabMenuShown);
        },
        shortcut: GLOBAL_SHORTCUTS.OPEN_DASHBOARD_LIST,
        isGlobal: true
      }]
    })]
  });
}
export default NavTabList;
//# sourceMappingURL=NavTabList.js.map